<template>
  <v-container class="px-10" fluid>
    <!-- Breadcrumbs -->
    <v-row>
      <v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          divider=">"
          class="px-0"
        ></v-breadcrumbs>
        <div class="d-flex justify-space-between">
          <h3 class="pageHeadline" t-data="page-headline">
            Appointments List
          </h3>
        </div>
      </v-col>
    </v-row>

    <snack-bar v-model="isCreateSuccess" :content="snackbarSuccess"></snack-bar>
    <snack-bar
      v-model="isCreateFail"
      :content="snackbarFail"
      type="error"
    ></snack-bar>

    <!-- Data table -->
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="4" t-data="search-panel">
            <search
              :search="searchPhase"
              label="Search by Patient name, Care provider"
              @enter="textSearch"
              @clear="clearSearch()"
            ></search>
          </v-col>
          <v-col cols="12" sm="6"></v-col>
          <v-col
            cols="12"
            sm="2"
            class="d-flex justify-end align-center"
            t-data="filter-panel"
          >
            <filter-dropdown @apply="handleApplyFilter"></filter-dropdown>
          </v-col>
        </v-row>
      </v-card-title>
      <v-layout fluid v-resize="onResize">
        <v-data-table
          :loading="isLoading"
          :options.sync="options"
          :headers="table.headers"
          :items="appointmentList"
          :items-per-page="table.pageSize"
          :server-items-length="totalAppointments"
          :footer-props="{'items-per-page-options': table.itemPerPages}"
          :sort-desc="true"
          :must-sort="false"
          class="elevation-1 custom-table"
          fixed-header
          style="width: 100%"
          :height="
            windowSize.y - heightOptions.header - heightOptions.tableFooter
          "
        >
          <template v-slot:item.action="{item}">
            <div>
              <v-icon
                t-data="edit-action"
                class="px-2 action-icon"
                @click="rowClick(item)"
                >mdi-pencil-outline</v-icon
              >
            </div>
          </template>
          <template v-slot:item.org_codename="{item}">{{
            item.org_codename.toUpperCase()
          }}</template>
          <template v-slot:item.department="{item}">{{
            item.department ? item.department.content.title : ''
          }}</template>
          <template v-slot:item.doctor="{item}">
            {{item.doctor ? item.doctor.content.prefix_name : ''}}
            {{item.doctor ? item.doctor.content.name : '' }}</template>
          <template v-slot:item.apt_date="{item}">
            <p class="mb-0">{{item.apt_date}}</p>
            {{timeFmt(item.apt_start_time)}}-{{timeFmt(item.apt_end_time)}}
          </template>
          <template v-slot:item.display_type="{item}">{{
            item.display_type in channelTextItems
              ? channelTextItems[item.display_type]
              : ''
          }}</template>
          <template v-slot:item.is_status="{item}">
            {{item.is_status}}
          </template>
          <template v-slot:item.for_pagekage="{item}">
            <div class="d-flex justify-center">
              <v-img
                aspect-ratio="1"
                v-show="item.for_pagekage === 1 ? true : false"
                max-height="24"
                max-width="24"
                src="/images/check-icon.png"
              ></v-img>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {
  searchHandler,
  snackbarSuccessContent,
  snackbarFailContent,
  convertTime
} from '@/helper/helper'
import FilterDropdown from '@/views/appointment/FilterDropdown'
import Search from '@/components/Search'
import SnackBar from '@/components/SnackBar'
import {displayTypeText} from '@/constants/appointment'

export default {
  components: {
    FilterDropdown,
    Search,
    SnackBar,
  },
  data() {
    return {
      pageName: 'Appointment',
      heightOptions: {
        header: 312,
        tableFooter: 59
      },
      windowSize: {
        x: 0,
        y: 0
      },
      isCreateSuccess: false,
      isCreateFail: false,
      snackTitle: 'created',
      searchPhase: '',
      options: {},
      action: {
        status: ''
      },
      table: {
        page: 1,
        pageSize: 25,
        itemPerPages: [25, 50, 100],
        headers: [
           {
            text: 'Actions',
            align: 'center',
            value: 'action',
            sortable: false,
            width: 20
          },
          {
            text: 'Code',
            align: 'left',
            sortable: false,
            value: 'apt_code',
            width: 50
          },
          {
            text: 'Patient name',
            align: 'left',
            value: 'cust_fullname',
            sortable: false,
            width: 170
          },
          {
            text: 'Branch',
            align: 'left',
            value: 'org_codename',
            sortable: false,
            width: 70
          },
          {
            text: 'Department',
            align: '',
            value: 'department',
            sortable: false,
            width: 150
          },
          {
            text: 'Care Provider',
            align: '',
            value: 'doctor',
            sortable: false,
            width: 170
          },
          {
            text: 'Appointment Date/Time',
            align: 'left',
            value: 'apt_date',
            sortable: false,
            width: 70
          },
          {
            text: 'Channel',
            align: 'center',
            value: 'display_type',
            sortable: false,
            width: 120
          },
          {
            text: 'Status',
            align: 'left',
            value: 'is_status',
            sortable: false,
            width: 30
          },
          {
            text: 'For package',
            align: 'center',
            value: 'for_pagekage',
            sortable: false,
            width: 120
          },

        ]
      },
      breadcrumbs: [
        {
          text: 'Dashboard',
          exact: true,
          href: '/'
        },
        {
          text: 'Appointments List',
          disabled: true,
          link: true,
          href: '/'
        }
      ],
      channelTextItems: displayTypeText
    }
  },
  created() {
    this.setListOrgInfo()
  },
  mounted() {
    let query = this.$route.query.isCreateSuccess
    let querySnackTitle = this.$route.query.snackTitle

    if (query) {
      this.$router.replace({})
      this.isCreateSuccess = query
      this.snackTitle = querySnackTitle
    }
  },
  computed: {
    snackbarSuccess() {
      return snackbarSuccessContent(this.pageName, this.snackTitle)
    },
    snackbarFail() {
      return snackbarFailContent(this.pageName, this.snackTitle)
    },
    ...mapState('appointment', [
      'appointmentList',
      'isLoading',
      'orgList',
      'totalAppointments',
    ])
  },
  methods: {
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    create() {
      this.$router.push({name: 'appointment-create'})
    },
    clearSearch() {
      this.setTextSearch('')
      this.options.page = 1
      this.fetch()
    },
    timeFmt: time => convertTime(time),
    textSearch(data) {
      this.searchPhase = data
      this.timer = searchHandler(this.timer, clearTimeout, async () => {
        this.setTextSearch(this.searchPhase.trim())
        this.options.page = 1
        await this.fetch()
      })
    },
    rowClick(pkg) {
      this.$router.push({name: 'appointment-edit', params: {id: pkg.id}})
    },
    handleApplyFilter() {
      this.options.page = 1
    },
    ...mapActions('appointment', [
      'fetch',
      'resetList',
      'setFieldSort',
      'setListOrgInfo',
      'setPage',
      'setPageSize',
      'setSort',
      'setTextSearch',
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.setTextSearch('')
    this.resetList()
    next()
  },

  watch: {
    options: {
      handler() {
        const {sortBy, sortDesc, page, itemsPerPage} = this.options
        this.setPage(page)
        this.setFieldSort(sortBy[0])
        this.setPageSize(itemsPerPage)
        this.setSort(sortDesc[0])
        this.fetch()
      },
      deep: true
    }
  }
}
</script>

<style>
</style>
